<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {}
    },
    methods: {},
}
</script>

<template>
    <div>
        <h4>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Suscripción</h4>
        <p>Libera tu corredor interior con nuestro plan de suscripción {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}! <strong>Obtén hasta un 50% de descuento cuando te suscribes</strong> a la recarga mensual de créditos, lo que significa más tiempo al volante por menos. Los créditos se pueden usar para reservar nuestros simuladores de carreras ultra-realistas y de alta gama, perfectos para ti y tus amigos. Desde Fórmula 1 hasta carreras GT, nuestros equipos ofrecen una experiencia totalmente inmersiva con retroalimentación de movimiento háptico.</p>
        <h4>Preguntas Frecuentes</h4>
        <p>
            <ul>
                <li><strong>¿Cómo funciona la suscripción?</strong> ¡Compras créditos a una tarifa con descuento, hasta un 50% de descuento!</li>
                <li><strong>¿Puedo usar créditos para amigos?</strong> Sí, comparte la experiencia reservando para otros.</li>
                <li><strong>¿Los créditos caducan?</strong> Sí, ¡úsalos o piérdelos!</li>
                <li><strong>¿Qué simuladores puedo usar?</strong> Puedes usar créditos en cualquier simulador. Simplemente estás seleccionando la cantidad de créditos que deseas recargar cada mes.</li>
                <li><strong>¿Cuánto tiempo debo mantener mi suscripción activa?</strong> Si cancelas tu suscripción dentro de 2 meses, se te cobrará el precio completo por las reservas que hayas hecho.</li>
            </ul>
        </p>
    </div>
</template>

<style lang="scss" scoped>
</style>
